$('.tooltip-toggler').find('i, svg, [name="cicle-info"]').attr('aria-hidden', 'true');

const $taxesToggler = $('.taxes-tooltip-toggler');
const $taxesBox = $('.taxes-tooltip-box');
const $dutiesToggler = $('.duties-tooltip-toggler');
const $dutiesBox = $('.duties-tooltip-box');

const show = ($box, $toggler) => {
  if ($box.length && $toggler.length) {
    $box
      .prop('hidden', false)
      .attr('aria-hidden', 'false')
      .addClass('visible');

    $toggler
      .attr('aria-expanded', 'true')
      .attr('aria-describedby', 'tax-tooltip-content');
  }
};

const hide = ($box, $toggler) => {
  if ($box.length && $toggler.length) {
    $box
      .prop('hidden', true)
      .attr('aria-hidden', 'true')
      .removeClass('visible');

    $toggler
      .attr('aria-expanded', 'false')
      .removeAttr('aria-describedby');
  }
};

$taxesToggler.on('mouseenter', () => show($taxesBox, $taxesToggler));
$taxesToggler.on('mouseleave', () => hide($taxesBox, $taxesToggler));
$taxesToggler.on('click', () => {
  const isVisible = $taxesToggler.attr('aria-expanded') === 'true';    
  isVisible ? hide($taxesBox, $taxesToggler) : show($taxesBox, $taxesToggler);
});

$dutiesToggler.on('mouseenter', () => show($dutiesBox, $dutiesToggler));
$dutiesToggler.on('mouseleave', () => hide($dutiesBox, $dutiesToggler));
$dutiesToggler.on('click', () => {
  const isVisible = $dutiesToggler.attr('aria-expanded') === 'true';
  isVisible ? hide($dutiesBox, $dutiesToggler) : show($dutiesBox, $dutiesToggler);
});

$(document).on('keydown', (e) => {
  if (e.key === 'Escape') {
    hide($taxesBox, $taxesToggler)
    hide($dutiesBox, $dutiesToggler);
  }
});